import React from 'react'
import './carousel.css'
import Carousel from 'react-bootstrap/Carousel';
import Banner1 from '../../assets/images/banners/1.png'
import Banner2 from '../../assets/images/banners/2.png'
import Banner3 from '../../assets/images/banners/3.png'
import Banner4 from '../../assets/images/banners/4.png'

import Banner1i from '../../assets/images/banners/img1.png'
import Banner2i from '../../assets/images/banners/img2.png'
import Banner3i from '../../assets/images/banners/img3.png'
import Banner4i from '../../assets/images/banners/img4.png'
import Banner5i from '../../assets/images/banners/img5.png'

const Banners = () => {
    return (
        <Carousel variant="dark" >
            <Carousel.Item>
                <img
                    className="bannerImg d-block w-100"
                    src={Banner1i}
                    alt="First slide"

                />
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="bannerImg d-block w-100"
                    src={Banner2i}
                    alt="Second slide"
                />
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="bannerImg d-block w-100"
                    src={Banner3i}
                    alt="Third slide"
                />
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="bannerImg d-block w-100"
                    src={Banner4i}
                    alt="Third slide"
                />
            </Carousel.Item>
            <Carousel.Item>
            <img
                className="bannerImg d-block w-100"
                src={Banner5i}
                alt="Third slide"
            />
        </Carousel.Item>
        </Carousel>
    )
}

export default Banners